var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.comments != null)?_c('response-text',{attrs:{"question":"Comments","answer":_vm.comments,"is_nested":_vm.is_nested}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }